import React from "react";

export default function OrderDetails({ order }) {
  return (
    <div className="profile-order-items expanded-background">
      {/* Order Info */}
      <div className="profile-order-info">
        {order.customer_phone && (
          <p>
            <strong>Phone No:</strong> {order.customer_phone}
          </p>
        )}

        {order.order_type === "Delivery" && (
          <>
            {order.delivery_address && (
              <p>
                <strong>Delivery Address:</strong> {order.delivery_address}
              </p>
            )}
            {order.postcode && (
              <p>
                <strong>Postcode:</strong> {order.postcode}
              </p>
            )}
            {order.delivery_fee != null && (
              <p>
                <strong>Delivery Fee:</strong> £
                {parseFloat(order.delivery_fee).toFixed(2)}
              </p>
            )}
          </>
        )}
      </div>

      <hr />

      {/* Items */}
      {order.items.map((item) => {
        const optionTotal = item.selectedOptionalOptions.reduce(
          (sum, opt) => sum + opt.price * opt.quantity,
          0
        );

        const itemTotal =
          (parseFloat(item.base_price || 0) +
            parseFloat(item.required_option_price || 0) +
            optionTotal) *
          (item.quantity || 1);

        return (
          <div key={item.id} className="profile-order-item">
            <div className="profile-order-item-header">
              <span className="profile-order-item-title">
                {item.name}
                {item.base_price > 0 && (
                  <> (£{parseFloat(item.base_price).toFixed(2)})</>
                )}
              </span>
            </div>

            {/* Required Option */}
            {item.required_option_id && (
              <div className="profile-order-item-option">
                <ul>
                  <li>
                    {item.required_option_name}
                    {item.required_option_price > 0 && (
                      <> (£{(item.required_option_price * item.quantity).toFixed(2)})</>
                    )}
                  </li>
                </ul>
              </div>
            )}

            {/* Optional Options */}
            {item.selectedOptionalOptions.length > 0 && (
              <div className="profile-order-item-option">
                <strong>Optional:</strong>
                <ul>
                  {item.selectedOptionalOptions.map((opt, idx) => (
                    <li key={idx}>
                      {opt.name} x {opt.quantity}
                      {opt.price > 0 && <> (£{(opt.price * opt.quantity).toFixed(2)})</>}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="profile-order-item-total-wrapper">
              <span className="profile-order-item-total-text">
                x {item.quantity} = £{itemTotal.toFixed(2)}
              </span>
            </div>

            <hr className="profile-order-item-divider" />
          </div>
        );
      })}

      {order.service_charge != null && order.service_charge > 0 && (
        <p>
          <strong>Service Charge:</strong> £
          {parseFloat(order.service_charge).toFixed(2)}
        </p>
      )}

      {order.notes?.trim() && (
        <p className="profile-order-notes">
          <strong>Notes:</strong> {order.notes}
        </p>
      )}
    </div>
  );
}